// extracted by mini-css-extract-plugin
export default {"activities":"BusinessHomeActivities_activities__cdIdU","activities_headers":"BusinessHomeActivities_activities_headers__iHWlZ","active":"BusinessHomeActivities_active__WWj0U"};